export const hasBeen90DaysSinceUpdated = (updatedAt: number | null) => {
  if (!updatedAt) {
    return false;
  }

  const ONE_SECOND_IN_MS = 1000;
  const TWENTY_FOURS_HOURS_IN_MS = 1000 * 60 * 60 * 24;

  const updatedDate = new Date(updatedAt * ONE_SECOND_IN_MS);
  const now = new Date();
  const diffTime = now.getTime() - updatedDate.getTime();
  const diffDays = Math.ceil(diffTime / TWENTY_FOURS_HOURS_IN_MS);

  return diffDays >= 90;
};
